module.exports = __webpack_public_path__ + "img/svg/background-login-modal.aab23585e296ce6d60b19ff91c1a8b01.svg";